<div class="d-flex flex-column align-items-center">
  <ibm-loading></ibm-loading>
  <strong class="loading-text">{{ uploaderService?.fileUploadStatus?.percentage }}%</strong>
</div>